import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Order } from '../../../../domain';
import OrderInfoDetail from '../../../../domain/order-info.interface';

@Component({
  selector: 'app-extended-row',
  templateUrl: './extended-row.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, DatePipe],
})
export class ExtendedRowComponent implements OnInit {
  @Output() openOrder = new EventEmitter<Order>();

  @Input() order: Order;

  public info: OrderInfoDetail[] = null;

  public title: string = '...';

  ngOnInit(): void {
    this.setTitle();
    this.getCustomInfo();
  }

  private setTitle(): void {
    this.title = this.order.getService();
    this.title += ' Order Detail';
  }

  private getCustomInfo(): void {
    this.info = this.order.getRowInfo();
  }

  public viewMore(): void {
    this.openOrder.emit(this.order);
  }
}
